import { render, staticRenderFns } from "./SupplierEvaluationform.vue?vue&type=template&id=db95acd4&scoped=true"
import script from "./SupplierEvaluationform.vue?vue&type=script&lang=js"
export * from "./SupplierEvaluationform.vue?vue&type=script&lang=js"
import style0 from "./SupplierEvaluationform.vue?vue&type=style&index=0&id=db95acd4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db95acd4",
  null
  
)

export default component.exports